import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

/**
 * Help Breadcrumbs Component
 *
 * Clean breadcrumb navigation with text links (not buttons)
 *
 * Why .hc-* classes instead of CSS modules: single source of truth in
 * resources/css/help-center.scss shared with Blade SSR.
 *
 * Location: resources/react/src/modules/help/components/help-breadcrumbs.jsx
 *
 * @component
 *
 * @param {Object} props
 * @param {string} props.category - Current category ID
 * @param {string} props.articleTitle - Current article title
 * @param {Array} props.navigation - Navigation structure to find category name
 *
 * @example
 * <HelpBreadcrumbs
 *   category="getting-started"
 *   articleTitle="How Customers Subscribe"
 *   navigation={navigationData}
 * />
 */
export const HelpBreadcrumbs = ({ category, articleTitle, navigation }) => {
  const navigate = useNavigate();

  const getCategoryName = () => {
    const cat = navigation.find((c) => c.id === category);
    return cat ? cat.title : category;
  };

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <nav className="hc-breadcrumbs" aria-label="Breadcrumb">
      <ol className="hc-breadcrumbs__list">
        {/* Home Link */}
        <li className="hc-breadcrumbs__item">
          <button
            type="button"
            className="hc-breadcrumbs__link"
            onClick={() => handleNavigate('/help-center')}
          >
            Help Center
          </button>
        </li>

        {/* Separator */}
        <li className="hc-breadcrumbs__separator" aria-hidden="true">
          <ChevronRight size={14} strokeWidth={2} />
        </li>

        {/* Category */}
        <li className="hc-breadcrumbs__item">
          <span className="hc-breadcrumbs__category">{getCategoryName()}</span>
        </li>

        {/* Separator */}
        <li className="hc-breadcrumbs__separator" aria-hidden="true">
          <ChevronRight size={14} strokeWidth={2} />
        </li>

        {/* Current Article */}
        <li className="hc-breadcrumbs__item">
          <span className="hc-breadcrumbs__current" aria-current="page">
            {articleTitle}
          </span>
        </li>
      </ol>
    </nav>
  );
};
